export default "__VITE_ASSET__MuiPvKKw__"